import phoneCodes from 'assets/phoneCodes.json'

/**
 * @param countryCode - country code
 * @returns phonecode
 */
export const getPhoneCodeByCountryCode = (countryCode: string) =>
  phoneCodes.find(({ code }) => code === countryCode.toUpperCase())?.dialCode
